import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import routesConfig from "./routes/routefile";
import SessionExpiredModal from "./components/SessionExpired/SessionExpiredModal";
import useIdleTimer from "./hooks/useIdleTimer";
import UserSessionHandler from "./components/login/userSessionHandler";

function App() {
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const interval = setInterval(() => {
        if (
          !isSessionExpired &&
          localStorage?.getItem("isSessionExpired") !== null
        ) {
          const sessionExpired =
            localStorage?.getItem("isSessionExpired") === "true" ? true : false;
          setIsSessionExpired(sessionExpired);
        } else {
          setIsSessionExpired(false);
        }
      }, 10000);
      
      return () => clearInterval(interval);
    }, 2500);
  }, [isSessionExpired]);

  const getRemainingTime = () => {
    const expiryTime = parseInt(localStorage.getItem("expiry_time") || "0", 10);
    const currentTime = Math.floor(Date.now() / 1000);
    const remainingTime = (expiryTime - currentTime) * 1000;
    return remainingTime > 0 ? remainingTime : 0;
  };

  const remainingTime = getRemainingTime();

  useIdleTimer(remainingTime, () => {
    setTimeout(() => {
      setIsSessionExpired(true);
    }, 2000);
  });

  return (
    <Router>
       <div data-testid={"AppDiv"}>
        <Routes>
          {routesConfig?.map((route, index) => (
            <Route key={index} path={route.path} element={<route.element />} />
          ))}
        </Routes>
        <SessionExpiredModal show={isSessionExpired} />
        <UserSessionHandler />
      </div>
    </Router>
  );
}

export default App;